import * as _ from "lodash";
import http from "../constant/api";

export const profileTriggerService = {
  listProfileTriggerByProfileId: async (profileId, filter) => {
    const status = _.get(filter, "status");
    const search = _.get(filter, "search");

    const query = {};
    if (!_.isNil(status)) {
      query.status = status;
    }
    if (search) {
      query.search = search;
    }
  
    const result = await http.get(
      `/api/profile-trigger/list/profile-id/${profileId}`,
      { params: query }
    );
  
    return result;
  },
  
  addProfileTrigger: async (data) => {
    const result = await http.post(`/api/profile-trigger/add`, data);

    return result;
  },
  editProfileTrigger: async (id, data) => {
    const result = await http.put(`/api/profile-trigger/${id}/edit`, data);

    return result;
  },
  changeProfileTriggerPosition: async (data) => {
    const result = await http.put(`/api/profile-trigger/change/position`, data);

    return result;
  },
  removeProfileTrigger: async (id) => {
    const result = await http.delete(`/api/profile-trigger/${id}/remove`);

    return result;
  },
  readProfileTrigger: async (id) => {
    const result = await http.get(`/api/profile-trigger/${id}/read`);

    return result;
  },
};
